<template>
    <v-container fluid ma-0 pa-0 px-4>
      <div class="fixed-header" :class="{'mobile': $vuetify.breakpoint.smAndDown}"><!-- if has summary fields add class 'with-summary' -->
    <v-layout  align-center fill-height class="fixed-header-wrapper">
      <v-flex shrink class="text-truncate" pr-4>
        <v-tooltip color="secondary" bottom>
          <template v-slot:activator="{ on }">
            <h2 v-on="on" class="p-relative text-truncate" >
              {{account && account.name}}
            </h2>
           </template>
            <span>{{account && account.name}}</span>
          </v-tooltip>
          <v-tooltip
            v-if="selectedEmailAccount && selectedEmailAccount.verifySentMailbox"
            color="secondary"
            bottom
          >
            <template v-slot:activator="{ on }">
              <v-chip
                v-on="on"
                small
                color="success"
                class="ml-2"
                text-color="white"
                label
              >
                Verification On
              </v-chip>
            </template>
            <span>Sent mailbox verification will confirm delivery and mark messages as verified.</span>
          </v-tooltip>
      </v-flex>
      <v-spacer></v-spacer>
       <v-divider vertical ></v-divider>
      <v-flex shrink fill-height class="action">
        <v-tooltip  color="secondary" bottom>
          <v-btn
            icon
            flat
            slot="activator"
            @click="refresh"
            >
            <v-icon color="secondary" size="20">
              refresh
            </v-icon>
          </v-btn>
          <span>Refresh Inbox</span>
          
        </v-tooltip>
      </v-flex>
       <v-divider vertical></v-divider>
      <v-flex shrink fill-height class="vert-dots">
        <v-menu nudge-top="30px" left offset-y origin="center center" transition="scale-transition">
          <v-btn
            flat
            slot="activator"
            icon
            class="ma-0 pa-0"
            dark
            color="secondary"
          >
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list dense>
                <v-list-tile @click="renameSearchDialog = true">
                  <v-icon class="mr-2" color="secondary">edit</v-icon>Rename saved search
                </v-list-tile>
                <v-list-tile color="error" @click="dialogDelete = true">
                  <v-icon class="mr-2" color="error">delete</v-icon>Delete saved search
                </v-list-tile>
              </v-list>
        </v-menu>
      </v-flex>
    </v-layout>
  </div>
    <v-flex xs12 px-0 mb-4 v-show="hideInbox">
      <v-layout wrap px-0> 
        <v-flex xs12 pt-1>
          <v-btn
              v-if="systemProvidedSearch && !searchToggled"
                v-on:click="searchToggled = !searchToggled"
                :ripple="false"
                flat
                class="search-button ma-0 mb-0 ml-0 mr-3"
              >
                <v-icon
                  size="20"
                  color="secondary"
                  class="mr-2 mt-0"
                >{{ searchToggled ? 'close' : 'search' }}</v-icon>
                {{ searchToggled ? 'Close search' : 'Search' }}
              </v-btn>
              <v-btn
              v-if="systemProvidedSearch && searchToggled"
                v-on:click="searchToggled = !searchToggled"
                :ripple="false"
                flat
                class="search-button ma-0 mb-0 ml-0 mr-3"
              >
                <v-icon
                  size="20"
                  color="secondary"
                  class="mr-2 mt-0"
                >{{ searchToggled ? 'close' : 'search' }}</v-icon>
                {{ searchToggled ? 'Close search' : 'Search' }}
              </v-btn>
              <v-btn
              v-if="systemProvidedSearch && searchToggled"
              :ripple="false" flat class="search-button ma-0 mb-0 ml-0"
              :disabled="!canSaveSearch"
                  @click="saveSearchDialog = true"
              >
                <v-icon size="20" color="secondary" class="mr-2 mt-0">save</v-icon>Save search
              </v-btn>
          <v-slide-y-transition>
            <v-layout row wrap class="mt-0" v-if="searchToggled">
              <v-flex xs12 pt-1>
                <v-text-field
                  box
                  class="cardcontainer-search-text pa-0 ma-0 body-1"
                  v-model="searchTerm"
                  label="Search"
                  color="secondary"
                  clear-icon="cancel"
                  @keyup.native.enter="search()"
                >
                  <template slot="append">
                    <v-icon>search</v-icon>
                  </template>
                </v-text-field>
              </v-flex>
            </v-layout>
          </v-slide-y-transition>
        </v-flex>
      </v-layout>
      <v-flex wrap class="mx-0 mt-1">
        <!-- Email Account Server Message Alert -->
        <v-flex xs12 v-if="emailAccountWithMessage && emailAccountWithMessage.hasMessage && emailAccountWithMessage.serverMessage" class="mb-3 mt-2">
          <v-alert
            :value="true"
            type="error"
            icon="warning"
            dismissible
            class="mb-0"
          >
            <div class="font-weight-bold mb-2">Email Account Error</div>
            <div class="server-message-content">{{ formattedServerMessage }}</div>
          </v-alert>
        </v-flex>
        <Loading :isLoading="isLoading">
          <v-divider></v-divider>
          <div v-for="(message, index) in messages" :key="message.id">
            <comms-message :messageData="message" v-on:reload="reload()"></comms-message>
            <v-divider></v-divider>
          </div>
          <div v-if="shouldPaginate" class="text-xs-center">
            <v-pagination
              class="mt-3"
              color="secondary"
              circle
              v-model="currentPage"
              :length="pageTotal"
              :total-visible="7"
            ></v-pagination>
          </div>
        </Loading>
      </v-flex>
    </v-flex>
    <v-dialog v-model="renameSearchDialog" max-width="500">
      <v-card class="pa-4">
        <v-card-title class="pa-0 pb-2">
          <h2>Rename your saved search</h2>
        </v-card-title>
        <v-flex class="mt-2">
          <v-text-field label="Saved search name" color="secondary" box v-model="newSearchName"></v-text-field>
        </v-flex>
        <v-card-actions class="ma-0 pa-0 pt-1">
          <v-btn color="success" @click="renameSearch">Save</v-btn>
          <v-btn @click="renameSearchDialog = false" color="secondary">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>    
    <v-dialog v-model="dialogDelete" max-width="500">
      <v-card class="pa-4">
        <v-card-title class="pa-0 pb-2">
          <h2>Delete Saved Search</h2>
        </v-card-title>
        <v-card-text class="pa-0">
          <p>Are you sure you want to delete this search?</p>
        </v-card-text>
        <v-card-actions class="ma-0 pa-0 pt-1">
          <v-btn @click="deleteSearch()" color="error">Yes, delete this search</v-btn>
          <v-btn @click="dialogDelete = false" color="secondary">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="saveSearchDialog" max-width="500">
      <v-card class="pa-4">
        <v-card-title class="pa-0 pb-2">
          <h2>Save Search</h2>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-text-field label="Search name" v-model="saveSearchName" class="white-box-field" box></v-text-field>
        </v-card-text>
        <v-card-actions class="ma-0 pa-0 pt-1">
          <v-btn :disabled="saveSearchName === ''" @click="saveSearch()" color="success">Save</v-btn>
          <v-btn @click="saveSearchDialog = false" color="error">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
  </v-container>
</template>

<script>
import CommsMessage from "@/components/comms/CommsMessage"
import Loading from "@/components/shared/Loading.vue"
import { mapState } from "vuex"
import Vue from 'vue'

export default {
  name: "CommsInbox",
  components: { CommsMessage, Loading },
  data: () => ({
    currentPage: 1,
    searchToggled: "",
    attachClipboard: "",
    searchTerm: "",
    saveSearchName: "",
    hideInbox: true,
    composeDialog: false,
    isLoading: false,
    canSaveSearch: false,
    saveSearchDialog: false,
    dialogDelete: false,
    renameSearchDialog: false,
    newSearchName: undefined,
    statusPollIntervalId: undefined,
    statusPollInFlight: false,
    statusPollIntervalMs: 5000,
    reloadInFlight: false
  }),
  mounted() {
    if (Vue && Vue.store) {
      Vue.store.dispatch('setPageTitle', "Commsroom")
    }
    this.evaluateStatusPolling()
  },
  beforeDestroy() {
    this.stopStatusPolling()
  },
  computed: {
    ...mapState({
      savedSearches: state => state.currentUser && state.currentUser.account && state.currentUser.account.savedSearches,
      savedSearchId: state => state.cbroute && state.cbroute.params && state.cbroute.params.saved_search_id,
      emailAccounts: state => state.currentUser.account.emailAccounts,
      pageSize: state =>
        state.currentUser && state.currentUser.me && state.currentUser.me.preferences && state.currentUser.me.preferences.pageSize
          ? state.currentUser.me.preferences.pageSize
          : 10,
      copiedMessage: state => state.ui.clipboard.commsMessage
    }),
    account() {
      if (this.savedSearches && this.savedSearchId != null) {
        const id = String(this.savedSearchId)
        const account = this.savedSearches.find(function(element) {
          return element && element.id != null && String(element.id) === id
        })
        return account
      }
      return undefined
    },
    selectedEmailAccount() {
      if (!this.account || !this.account.query || !this.emailAccounts) {
        return null
      }
      try {
        const originalQuery = this.account.query.split(" AND")[0]
        const emailAccountIdMatch = originalQuery.match(/emailAccountId:(\d+)/)
        if (emailAccountIdMatch) {
          const emailAccountId = parseInt(emailAccountIdMatch[1], 10)
          return this.emailAccounts.find(account => account.id === emailAccountId) || null
        }
      } catch (error) {
        console.error("Error parsing email account ID from query:", error)
      }
      return null
    },
    messages() {
      if (this.account && this.account.contents && this.account.contents.messages) {
        return this.account.contents.messages
      } else {
        return []
      }
    },
    totalItems() {
      if (
        this.account &&
        this.account.contents &&
        this.account.contents.total
      ) {
        return this.account.contents.total
      } else {
        return 0
      }
    },
    shouldPaginate() {
      return this.totalItems > this.pageSize
    },
    pageTotal() {
      let pageCount = 0
      if (this.shouldPaginate) {
        pageCount = Math.ceil(this.totalItems / this.pageSize)
      }
      return pageCount
    },
    systemProvidedSearch() {
      return this.savedSearchId && !!this.savedSearchId.match(/[a-zA-Z]/)
    },
    emailAccountWithMessage() {
      // Extract email account ID from saved search query
      if (!this.selectedEmailAccount) {
        return null
      }
      
      if (this.selectedEmailAccount.hasMessage && this.selectedEmailAccount.serverMessage) {
        return this.selectedEmailAccount
      }
      
      return null
    },
    hasPendingMessageStatuses() {
      return this.messages.some(message => message && message.sendStatus === "sending")
    },
    formattedServerMessage() {
      if (!this.emailAccountWithMessage || !this.emailAccountWithMessage.serverMessage) {
        return ""
      }
      
      const message = this.emailAccountWithMessage.serverMessage
      
      // Try to parse and format timestamp if it exists
      // Format: [2025-11-04T12:30:00.000Z] Message text
      const timestampMatch = message.match(/^\[([\dTZ.:-]+)\]\s*(.+)$/)
      
      if (timestampMatch) {
        try {
          const timestamp = new Date(timestampMatch[1])
          const messageText = timestampMatch[2]
          
          // Format timestamp in a readable format
          const formattedDate = timestamp.toLocaleString(undefined, {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            timeZoneName: 'short'
          })
          
          return `[${formattedDate}] ${messageText}`
        } catch (e) {
          // If date parsing fails, return original message
          return message
        }
      }
      
      // Return message as-is if no timestamp format detected
      return message
    }
  },
  watch: {
    copiedMessage() {
      this.attachClipboard = true
    },
    currentPage() {
      this.reload()
    },
    searchTerm() {
      if (this.searchTerm === "") {
        this.reload()
      }
    },
    savedSearchId() {
      if (this.savedSearchId) {
        this.reload()
      }
    },
    searchToggled() {
      if (!this.searchToggled && this.searchTerm !== "") {
        this.searchTerm = ""
        this.reload()
      }
    },
    messages: {
      handler() {
        this.evaluateStatusPolling()
      },
      deep: true
    }
  },
  methods: {
    evaluateStatusPolling() {
      if (this.hasPendingMessageStatuses) {
        this.startStatusPolling()
      } else {
        this.stopStatusPolling()
      }
    },
    startStatusPolling() {
      if (this.statusPollIntervalId) {
        return
      }
      this.statusPollIntervalId = window.setInterval(() => {
        this.refreshStatuses()
      }, this.statusPollIntervalMs)
      this.refreshStatuses()
    },
    stopStatusPolling() {
      if (this.statusPollIntervalId) {
        clearInterval(this.statusPollIntervalId)
        this.statusPollIntervalId = undefined
      }
    },
    async refreshStatuses() {
      if (this.statusPollInFlight || this.reloadInFlight || !this.savedSearchId) {
        return
      }
      this.statusPollInFlight = true
      const currentPage = Math.max(this.currentPage - 1, 0)
      try {
        await this.$store.dispatch("reloadSavedSearches", {
          currentPage,
          pageSize: this.pageSize,
          savedSearchId: this.savedSearchId
        })
      } catch (error) {
        console.error("Failed to refresh message statuses", error)
      } finally {
        this.statusPollInFlight = false
        if (!this.hasPendingMessageStatuses) {
          this.stopStatusPolling()
        }
      }
    },
    async search() {
      if (this.searchTerm !== "" && this.account) {
        this.isLoading = true
        const savedSearch = {
          id: this.account.id,
          name: this.account.name,
          query: this.account.query,
          systemProvided: this.account.systemProvided
        }
        await this.$store.dispatch("searchSavedSearch", {
          savedSearch: savedSearch,
          queryString: this.searchTerm,
          page: this.currentPage - 1,
          pageSize: this.pageSize
        })
        this.saveSearchName = ""
        this.canSaveSearch = true
        this.isLoading = false
      }
      this.evaluateStatusPolling()
    },
    async refresh() {
      if (this.reloadInFlight || !this.savedSearchId) {
        return
      }
      this.reloadInFlight = true
      this.isLoading = true
      this.currentPage = 1
      try {
        await this.$store.dispatch("reloadSavedSearches", {
          currentPage: this.currentPage - 1,
          pageSize: this.pageSize,
          savedSearchId: this.savedSearchId
        })
        this.canSaveSearch = false
      } finally {
        this.isLoading = false
        this.reloadInFlight = false
        this.evaluateStatusPolling()
      }
    },
    async reload() {
      if (this.reloadInFlight || !this.savedSearchId) {
        return
      }
      this.reloadInFlight = true
      this.isLoading = true
      try {
        await this.$store.dispatch("reloadSavedSearches", {
          currentPage: this.currentPage - 1,
          pageSize: this.pageSize,
          savedSearchId: this.savedSearchId
        })
        this.canSaveSearch = false
      } finally {
        this.isLoading = false
        this.reloadInFlight = false
        this.evaluateStatusPolling()
      }
    },
    async renameSearch() {
      if (this.newSearchName && this.newSearchName.length > 0 && this.account) {
        this.$store.dispatch("renameSavedSearch", { savedSearchId: this.account.id, newSearchName: this.newSearchName })
      }
      this.renameSearchDialog = false
    },
    async deleteSearch() {
      this.dialogDelete = false
      if (!this.account || !this.account.query) {
        return
      }
      const originalQuery = this.account.query.split(" AND")[0]
      const defaultId = parseInt(originalQuery.split("emailAccountId:")[1]) + "-inbox"
      const success = await this.$store.dispatch(
        "deleteSavedSearch",
        { savedSearchId: this.account.id, defaultId: defaultId }
      )
      if (success) {
        this.searchToggled = false
      }
    },
    async saveSearch() {
      if (!this.account || !this.account.query) {
        return
      }
      const query = this.account.query + " AND " + this.searchTerm
      const savedSearch = await this.$store.dispatch("createSavedSearch", {
        name: this.saveSearchName,
        query,
        pageSize: this.pageSize
      })
      this.saveSearchDialog = false
      if (savedSearch) {
        this.isLoading = true
        this.searchTerm = ""
        this.searchToggled = false
        this.$router.push({
          name: "CommsInbox",
          params: { saved_search_id: savedSearch.id }
        })
      }
    }
  }
}
</script>

<style>
.no-box-shadow {
  -webkit-box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0),
    0px 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px 0px rgba(0, 0, 0, 0);
  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px 0px rgba(0, 0, 0, 0),
    0px 0px 0px 0px rgba(0, 0, 0, 0);
  max-height: 80% !important;
}

.email-row {
  padding-right:390px !important;
}

.email-row-mobile {
  padding-right:50px !important;
  padding-left: 0 !important;
}

.full-width {
  width: 100% !important;
}

.fixed-bar {
  width: 100% !important;
  padding-right: 100px !important;
}

.fixed-bar h4 {
  max-width: 100% !important;
}

.email-row-mobile h4 {
  max-width: calc(100% - 100px) !important;
}

.unread {
  font-weight: 500;
}

.v-expansion-panel.comms-room .v-expansion-panel__header {
  padding: 0 !important;
}

.v-expansion-panel.comms-room
  .v-expansion-panel__container--active
  .v-expansion-panel__header {
  background: white;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.v-expansion-panel__container.email-conversation .v-expansion-panel__header {
  padding: 0 !important;
}

.v-expansion-panel__container.email-conversation .v-avatar.expansion-avatar {
  height: 35px !important;
  width: 35px !important;
}

.v-expansion-panel__container--active.email-conversation
  .v-avatar.expansion-avatar {
  height: 50px !important;
  width: 50px !important;
  margin-top: 12px;
}

.v-expansion-panel__container--active.email-conversation
  .v-avatar.expansion-avatar.status:after {
  left: 0px;
}

.v-expansion-panel__container.email-conversation .recipients {
  display: none;
}

.v-expansion-panel__container--active.email-conversation .recipients {
  display: block;
}

.v-expansion-panel__container.email-conversation .email-right-actions {
  padding: 6px 0 0 0;
}

.v-expansion-panel__container--active.email-conversation .email-right-actions {
  padding: 14px 0 0 0;
}

.v-expansion-panel__container.email-conversation .email-right-actions .v-btn {
  display: none;
}

.v-expansion-panel__container--active.email-conversation
  .email-right-actions
  .v-btn {
  display: inline-block;
}

.v-expansion-panel__container.email-conversation .expansion-avatar .initials {
  font-size: 13px;
  padding: 0px 0 0 0;
}

.v-expansion-panel__container--active.email-conversation
  .expansion-avatar
  .initials {
  font-size: 20px;
  padding: 10px 0 13px 0;
}

.theme--light.v-expansion-panel .v-expansion-panel__container {
  border-top: none;
}

.email-attach-bar {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  color: #ffffff !important;
  background: rgb(233, 169, 22); /* Old browsers */
  background: -moz-linear-gradient(
    top,
    rgba(233, 169, 22, 1) 0%,
    rgba(219, 120, 0, 1) 100%
  ); /* FF3.6-15 */
  background: -webkit-linear-gradient(
    top,
    rgba(233, 169, 22, 1) 0%,
    rgba(219, 120, 0, 1) 100%
  ); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(
    to bottom,
    rgba(233, 169, 22, 1) 0%,
    rgba(219, 120, 0, 1) 100%
  ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  z-index: 999;
}

.v-expansion-panel.comms-room.border-bottom {
  border-bottom:1px solid rgba(0,0,0,0.12);
}

.no-scroll-afterall {
  overflow-Y:scroll !important;
}
</style>
